import { Box, Typography } from "@mui/material";
import { useState } from "react";
import {
  CommonButton,
  CustomRequiredInputLabel,
  CustomTextFeild,
} from "../../common/StyledComponents/StyledFields";
import { useFormik } from "formik";
import { object, string } from "yup";
import { textFieldStyles } from "../ExpenseRequest/CreateExpenseRequest/CreateExpenseRequest";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";
import ViewExpenseRequest from "./ViewExpenseRequest/ViewExpenseRequest";
import { Toaster } from "react-hot-toast";

const PrintVoucher = () => {
  const [viewExpenseRequest, setViewExpenseRequest] = useState(false);
  const [referenceNumber, setReferenceNumber] = useState("");

  const initialValues = {
    referenceNumber: "",
  };

  const validationSchema = object().shape({
    referenceNumber: string()
      .trim()
      .required("Please enter the Reference Number"),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit(values) {
      setViewExpenseRequest(true);
      setReferenceNumber(values.referenceNumber);
    },
    enableReinitialize: true,
  });

  const renderPrintVoucherComponent = () => {
    return (
      <Box className="common_box_shadow" sx={{ mt: "20px" }}>
        <Box
          sx={{
            width: { xs: "100%", sm: "50%" },
            maxWidth: "350px",
            mr: { xs: "0px", sm: "20px" },
          }}
        >
          {CustomRequiredInputLabel("Enter Reference Number", true)}
          <CustomTextFeild
            fullWidth
            required
            value={formik.values.referenceNumber}
            sx={textFieldStyles.textField}
            onChange={formik.handleChange}
            name="referenceNumber"
            placeholder="Reference Number"
          />
          {formik.touched.referenceNumber &&
            formik?.errors?.referenceNumber && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {formik?.errors?.referenceNumber}
              </Typography>
            )}
        </Box>
        <CommonButton
          onClick={() => {
            formik.handleSubmit();
          }}
          sx={{ mr: "10px", mt: "20px" }}
        >
          <ButtonLoader isBtnLoading={false} btnText={"Retrieve Info"} />
        </CommonButton>
      </Box>
    );
  };

  const renderViewExpenseRequest = () => {
    return (
      <Box
        className="common_box_shadow"
        sx={{ mt: "20px", p: "0px !important" }}
      >
        <ViewExpenseRequest
          open={viewExpenseRequest}
          handleClose={() => {
            setViewExpenseRequest(false);
          }}
          referenceNumber={referenceNumber}
          renderWithoutDialog={true}
        />
      </Box>
    );
  };

  return (
    <>
      <Toaster />
      <Typography className="sub_heading">Print Voucher</Typography>
      {renderPrintVoucherComponent()}
      {viewExpenseRequest && renderViewExpenseRequest()}
    </>
  );
};

export default PrintVoucher;
